<template>
  <div id="books_teacher">
    <div v-if="books.length" class="grid grid--wide">
      <div class="xs-12 myhome-home__mybooks-section">
        <div class="myhome-home__mybooks-header">
          <h2 class="dea-heading--medium__l">
            I miei libri
          </h2>
        </div>
        <div class="myhome-home__mybooks-container">
          <ActivatedBooksList
            :async-conf="$root.asyncConf"
            columns-class="bookslist__column bookslist__column--myhome"
            :list-columns="12"
            :grid-wide="false"
            :extra-info-on-card="true"
            :show-catalog-link="!compactLayout"
            :show-modal-link="!compactLayout"
            :books="books"
            :link-color="user.targetCss.colorMod"
            :student="user.student"
            :slice-size="numBooksShown"
            @save-bookmark="addBookmark"
            @delete-bookmark="removeBookmark"
            @update-books-list="$emit('update-books-list')"
          >
            <div v-if="books.length > numBooksCompactLayout" class="myhome-home__mybooks-link">
              <router-link
                class="dea-links dea-links--align-right dea-links--no-border dea-links--decoration"
                :class="`dea-links--decoration-${user.targetCss.colorMod}`"
                :to="{ name: 'books' }"
              >
                <span class="dea-links__label dea-heading--medium-l">
                  <template v-if="books.length === numBooksShown"> Vedi dettagli </template>
                  <template v-else-if="books.length > numBooksShown">
                    Vai all'elenco completo
                  </template>
                </span>
                <span class="icon dea-links__icon dea-ico-go-to" aria-label="icona vai a"></span>
              </router-link>
            </div>
          </ActivatedBooksList>
        </div>
      </div>
    </div>
    <div v-else class="grid grid--wide">
      <div class="xs-12">
        <h3 class="dea-heading--medium__l">I miei libri</h3>
        <EmptyBook
          :link-color="user.targetCss.colorMod"
          :parent="user.parent"
          :student="user.student"
          :user="user"
          @open-activation-modal="$emit('open-activation-modal')"
          @open-evaluation-modal="$emit('open-evaluation-modal')"
        />
      </div>
    </div>
    <div v-if="aed.length > 0">
      <div class="grid grid--wide">
        <h3 class="xs-12 myhome-home__aed-title dea-heading--medium__l">
          Portali e strumenti utili
        </h3>
      </div>
      <AeDCardList v-if="loaded" :items="aed" />
    </div>
  </div>
</template>

<script>
import handleWindowResize from "deascuola-storybook/src/components/mixins/handleWindowResize";
import variables from "@/styles/variables.scss";
import AeDCardList from "@/components/patterns/AeDCardList";
import EmptyBook from "~/components/books/components/EmptyBook";
import ActivatedBooksList from "~/components/books/components/ActivatedBooksList";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";

export default {
  name: "HomeTeacherBooks",
  components: { AeDCardList, EmptyBook, ActivatedBooksList },
  mixins: [BookmarkActions, handleWindowResize],
  props: {
    books: {
      type: Array,
      required: true,
    },
    aed: {
      type: Array,
      required: true,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numBooksShown: 5,
    };
  },
  computed: {
    numBooksCompactLayout() {
      return this.numBooksShown - 1;
    },
    compactLayout() {
      return this.books.length > this.numBooksCompactLayout;
    },
  },
  methods: {
    handleWindowResize(event) {
      if (this.getWindowWidth(event) < variables.bpSizeMedium) this.numBooksShown = 4;
      if (this.getWindowWidth(event) < variables.bpSizeSmallMedium) this.numBooksShown = 6;
      else this.numBooksShown = 5;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/system.utils";

.myhome-home__aed-title {
  margin: $space-xx-small;
}
</style>
